import * as React from 'react';
import { SubtotalsListItem } from './SubtotalsListItem';
import { translate } from 'react-i18next';
export var Taxes = translate()(function (_a) {
    var t = _a.t, taxes = _a.taxes, moneyFormatter = _a.moneyFormatter;
    return taxes ? (React.createElement(React.Fragment, null, taxes
        .filter(function (_a) {
        var taxed = _a.taxed.serializedValue;
        return taxed !== undefined;
    })
        .map(function (_a, index) {
        var taxed = _a.taxed.serializedValue, taxRate = _a.rate.serializedValue, name = _a.name;
        return (React.createElement(SubtotalsListItem, { key: index, dataHook: "tax-".concat(name, "-").concat(taxRate), label: t('price-quote.view.totals.tax-rate', {
                name: name,
                rate: taxRate,
            }), value: moneyFormatter(taxed) }));
    }))) : null;
});
//# sourceMappingURL=Taxes.js.map